import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import { showToast } from "../pages/EventForm"; // Optional: use shared toast

const PaymentSettings = ({ eventId }) => {
  const [enableRazorpay, setEnableRazorpay] = useState(false);
  const [enableStripe, setEnableStripe] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(0.0);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // Extract full slug from URL (e.g. idevtek/psa-event)
  const getSlug = () => {
    const path = window.location.pathname;
    const parts = path.split("/");
    return parts.slice(-2).join("/"); // last two segments
  };

  const slug = getSlug();

  useEffect(() => {
    if (!slug) return;

    axios
      .get(`${API_BASE_URL}/event/${slug}/payment-settings`, { withCredentials: true })
      .then((res) => {
        setEnableRazorpay(!!res.data.enable_razorpay); // Map legacy field
        setEnableStripe(!!res.data.enable_stripe);
        setPaymentAmount(parseFloat(res.data.payment_amount) || 0);
      })
      .catch(() => showToast("Failed to load payment settings", "error"));
  }, [slug]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.post(
        `${API_BASE_URL}/event/${slug}/payment-settings`,
        {
          enable_razorpay: enableRazorpay,
          enable_stripe: enableStripe,
          payment_amount: parseFloat(paymentAmount) || 0,
        },
        { withCredentials: true }
      );
      showToast("Payment settings saved!");
      setStatus("");
    } catch (err) {
      showToast("Failed to save settings", "error");
      setStatus("Error saving settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow-sm border">
      <div className="title-line2 pt-0">
        <h5 className="mb-0 fw700">Payment Settings</h5>
      </div>

      {/* Razorpay */}
      <div className="form-check form-switch mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="razorpaySwitch"
          checked={enableRazorpay}
          onChange={() => setEnableRazorpay(!enableRazorpay)}
          disabled={loading}
        />
        <label className="form-check-label" htmlFor="razorpaySwitch">
          Enable Razorpay
        </label>
      </div>

      {/* Stripe */}
      <div className="form-check form-switch mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="stripeSwitch"
          checked={enableStripe}
          onChange={() => setEnableStripe(!enableStripe)}
          disabled={loading}
        />
        <label className="form-check-label" htmlFor="stripeSwitch">
          Enable Stripe
        </label>
      </div>

      {/* Payment Amount */}
      <div className="mb-3">
        <label htmlFor="paymentAmount" className="form-label">
          Payment Amount (INR)
        </label>
        <div className="input-group">
          <span className="input-group-text">₹</span>
          <input
            type="number"
            min="0"
            step="0.01"
            id="paymentAmount"
            className="form-control"
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="form-text">Set to 0 for free events</div>
      </div>

      <button
        onClick={handleSave}
        className="btn btn-success"
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" />
            Saving...
          </>
        ) : (
          "Save Settings"
        )}
      </button>

      {status && <div className="mt-3 alert alert-info p-2">{status}</div>}
    </div>
  );
};

export default PaymentSettings;